import { render, staticRenderFns } from "./GroupAppointmentCal.vue?vue&type=template&id=61c66872&scoped=true"
import script from "./GroupAppointmentCal.vue?vue&type=script&lang=js"
export * from "./GroupAppointmentCal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c66872",
  null
  
)

export default component.exports